import Configuration from '@/agilis/util/Configuration'
import { mapActions } from 'vuex'
import ConfigurationMobile from '@/agilis/mobile/util/ConfigurationMobile'
export default {
  name: 'searchPaginatedMobileMixin',
  data () {
    return {
      page: 2,
      loadingMoreItems: false,
      items: [],
      itemsCount: 0,
      searchTxt: '',
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        mustSort: true
      }
    }
  },
  computed: {
    cardItemList: {
      get: function () {
        return this.items
      },
      set: function (newValue) {
        this.items = newValue
      }
    }
  },
  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError',
      'notifyWarning': 'notificationStore/notifyWarning',
      'removeMessage': 'notificationStore/removeMessage',
      'notifyUserConfirm': 'notificationStore/notifyUserConfirm'
    }),

    fetchData () {
      if (this.mode === 'insert' || this.mode === 'edit' || this.mode === 'view') return

      if (!this.loading && !this.isDashboardView) {
        // loading flag check is to prevent double fetch
        // from DataTablePaginated.watch and DataTable.mount
        this.loading = true
        const url = this.searchApi
        const body = ConfigurationMobile.listTable.paginatedRequestBody(this.dataTableConfiguration, this.options, this.searchTxt, this.filterArray, this.filterHeaders)
        const config = this.$axios.agilisRequestConfig(url)
        this.$axios
          .post(url, body, config)
          .then(async (response) => {
            const responseItems = Array.isArray(response.data) ? response.data : response.data.items
            const items = Configuration.datatable.decorateItems(this.dataTableConfiguration, responseItems)
            // Regular flow: apply results
            this.cardItemList = items
            this.itemsCount = response.data.totalItems
            this.loading = false
          })
          .catch((error) => {
            this.notifyError(error)
            this.loading = false
          })
      }
    },

    handleSearchTxtInput (txt) {
      this.searchTxt = txt
      this.options.page = 1
      this.fetchData()
      this.dumpUserAction({ search: this.searchTxt })
    },
    // When the user scrolls down the list and reaches the end of the page,
    // the method will be activated. It loads 5 new elements each time it is activated.
    // A loading system will give the user visibility of the loading of elements.
    async onScroll () {
      try {
        if (this.itemsCount > this.cardItemList.length) {
          const scrollHeight = document.documentElement.scrollHeight
          const scrollTop = document.documentElement.scrollTop
          const clientHeight = document.documentElement.clientHeight
          if (scrollTop + clientHeight >= scrollHeight - 20 && !this.isLoading && this.itemsCount > this.cardItemList.length) {
            this.loadingMoreItems = true
            setTimeout(async () => {
              await this.loadMoreData()
            }, 800)
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async loadMoreData () {
      if (this.mode === 'view' || this.cardItemList.length >= this.itemsCount) return

      const url = this.searchApi
      const page = this.page
      this.page++

      const options = {
        page,
        itemsPerPage: 5,
        sortBy: [],
        sortDesc: [],
        mustSort: true
      }

      const body = Configuration.datatable.paginatedRequestBody(this.dataTableConfiguration, options, this.searchTxt, this.filterArray, this.filterHeaders)
      const config = this.$axios.agilisRequestConfig(url)

      try {
        const response = await this.$axios.post(url, body, config)
        const responseItems = Array.isArray(response.data) ? response.data : response.data.items
        const responseDecoratedItems = this.decorateItems(responseItems)

        // Rimuovi gli elementi duplicati
        const uniqueItems = responseDecoratedItems.filter(item =>
          !this.cardItemList.map(item => JSON.stringify(item)).includes(JSON.stringify(item))
        )
        this.cardItemList = [...this.cardItemList, ...uniqueItems]
        this.itemsCount = response.data.totalItems
      } catch (error) {
        this.notifyError(error)
      } finally {
        this.loadingMoreItems = false
      }
    }

  }

}
